import "../styles/cpn/cpn.scss";
import "../styles/cpn/cpn.sass";

export default {};
